export interface ModelRuleChangeProfil {
  action: ChangeProfilAction;
  caracs: ChangeProfilCarac;
  value: string;
}

export enum ChangeProfilAction {
  Replace = 0,
  Add = 1,
}

export enum ChangeProfilCarac {
  ground_adv = 0,
  ground_mar = 1,
  fly_adv = 2,
  fly_mar = 3,
  dis = 4,
  evoked = 5,
  hp = 6,
  def = 7,
  res = 8,
  arm = 9,
  aeg = 10,
  att = 11,
  of = 12,
  str = 13,
  ap = 14,
  agi = 15,
  M = 16,
  WS = 17,
  BS = 18,
  S = 19,
  T = 20,
  W = 21,
  I = 22,
  A = 23,
  E = 24,
  LD = 25,
}
